// src/Components/Includes/Generator/Types/PixQrCode.js
import React, { useEffect } from "react";
import PixKeyForm from "./PixKeyForm";
import usePixQrCode from "../../../../hooks/usePixQrCode";

const PixQrCode = ({ setQrData }) => {
    const {
        pixKey,
        amount,
        description,
        pixType,
        allowUserToEnterAmount,
        qrData,
        handlePixKeyChange,
        handleAmountChange,
        handleDescriptionChange,
        handlePixTypeChange,
        handleAllowUserToEnterAmountChange,
        handleBeneficiaryNameChange,
        handleBeneficiaryCityChange,
        beneficiaryName,
        beneficiaryCity
    } = usePixQrCode();

    

    useEffect(() => {
        setQrData(qrData);
    }, [qrData, setQrData]);


    return (
        <div className="pix-qrcode">
            <PixKeyForm
                pixKey={pixKey}
                amount={amount}
                description={description}
                pixType={pixType}
                allowUserToEnterAmount={allowUserToEnterAmount}
                handlePixKeyChange={handlePixKeyChange}
                handleAmountChange={handleAmountChange}
                handleDescriptionChange={handleDescriptionChange}
                handlePixTypeChange={handlePixTypeChange}
                handleAllowUserToEnterAmountChange={handleAllowUserToEnterAmountChange}
                handleBeneficiaryNameChange={handleBeneficiaryNameChange}
                handleBeneficiaryCityChange={handleBeneficiaryCityChange}
                beneficiaryName={beneficiaryName}
                beneficiaryCity={beneficiaryCity}
            />
        </div>
    );
};

export default PixQrCode;